'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2; // import AddIcon from "material-ui-icons/AddCircleOutline";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = require('material-ui');

var _FilterList = require('material-ui-icons/FilterList');

var _FilterList2 = _interopRequireDefault(_FilterList);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AddFilter = (_temp2 = _class = function (_Component) {
  _inherits(AddFilter, _Component);

  function AddFilter() {
    var _temp, _this, _ret;

    _classCallCheck(this, AddFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      opened: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  AddFilter.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        inputFields = _props.inputFields,
        _onChange = _props.onChange,
        other = _objectWithoutProperties(_props, ['inputFields', 'onChange']);

    var opened = this.state.opened;
    var content = null;

    if (opened) {
      content = _react2.default.createElement('select', _extends({}, other, {
        onChange: function onChange(event) {
          _onChange(event);

          _this2.setState({
            opened: false
          });
        }
      }), _react2.default.createElement('option', {
        value: ''
      }), inputFields.map(function (n) {
        var name = n.name,
            type = n.type;
        return _react2.default.createElement('option', {
          key: name,
          value: name
        }, name);
      }));
    } else {
      // content = <Button
      //   size="small"
      //   onClick={event => {
      //     this.setState({
      //       opened: true,
      //     });
      //   }}
      // >
      //   <AddIcon
      //   /> Add filter
      // </Button>
      content = _react2.default.createElement(_materialUi.IconButton, {
        onClick: function onClick(event) {
          _this2.setState({
            opened: true
          });
        }
      }, _react2.default.createElement(_FilterList2.default, null));
    }

    return content;
  };

  return AddFilter;
}(_react.Component), _class.defaultProps = {// opened: false,
}, _temp2);
AddFilter.propTypes = process.env.NODE_ENV !== "production" ? {
  inputFields: _propTypes2.default.array.isRequired // opened: PropTypes.bool.isRequired,

} : {};
exports.default = AddFilter;
module.exports = exports['default'];